import { PlanningCardFieldDescriptor } from '../planning-card-field';

/**
 * Card fields for the ProductionFolder card, in display order. The header (number/customer/status) is
 * listed first as `fixed` — always shown, locked in the config panel. `schedule` is a synthetic key
 * gating the computed preferred-production-date line.
 */
export const PRODUCTION_FOLDER_CARD_FIELDS: PlanningCardFieldDescriptor[] = [
  { key: 'number', labelKey: 'Doc::Planning:CardField:Number', fixed: true },
  { key: 'customer', labelKey: 'Doc::Planning:CardField:Customer', fixed: true },
  { key: 'status', labelKey: 'Doc::Planning:CardField:Status', fixed: true },
  { key: 'manufacturer', labelKey: '::Manufacturer' },
  { key: 'responsible', labelKey: '::Responsible' },
  { key: 'schedule', labelKey: 'Doc::EndProdDate' },
];

/**
 * Typed view of a ProductionFolder item's `PlanningItemDto.displayFields` payload. Mirrors the backend
 * `ProductionFolderPlanningItemFieldsDto` record (Digiwall.GoliathDocuments.Planning) — keep the two in sync.
 * `displayFields` is transported as a loosely-typed object, so the card casts it to this interface.
 */
export interface ProductionFolderPlanningItemFieldsDto {
  displayNumber?: string;
  customer?: string;
  manufacturer?: string;

  preferredProductionDate?: string;
  plannedDate?: string;
  plannedDurationHours?: number;
  responsible?: string;

  // Filter fields — ids used by the client-side board filter predicate (not shown on the card).
  // Kept in sync with the backend record's filter-field block.
  customerId?: string;
  dayBookId?: string;
  manufacturerId?: string;
  description?: string;
}
